import { createFileRoute, useNavigate } from '@tanstack/react-router'

import { WorkflowRoute } from '@/app/routes/_app/workflows/workflows'
import { FormPreviewRoute } from '@/app/routes/_app/workflows/workflows/form/preview/$id'
import { GenerateFormPage } from '@/pages/generate-form'

export const Route = createFileRoute('/_app/workflows/workflows/generate')({
  component: RouteComponent,
})

export const GenerateFormRoute = Route

function RouteComponent() {
  const navigate = useNavigate()
  return (
    <GenerateFormPage
      backTo={WorkflowRoute.to}
      onFormCreated={(formId) => navigate({ to: FormPreviewRoute.to, params: { id: formId } })}
    />
  )
}
